<template>
  <!-- page-wrapper Start-->
  <div class="page-wrapper compact-wrapper" id="pageWrapper">
    <div class="page-body-wrapper">
      <div class="page-body">
        <!-- Breadcrumb & Title -->
        <div class="container-fluid">
          <div class="page-title">
            <div class="row">
              <div class="col-12 col-sm-6">
                <h3>Invoice Details</h3>
              </div>
              <div class="col-12 col-sm-6">
                <ol class="breadcrumb">
                  <li class="breadcrumb-item">
                    <a class="home-item" href="/"><i data-feather="home"></i></a>
                  </li>
                  <li class="breadcrumb-item">Dashboard</li>
                  <li class="breadcrumb-item">Operation</li>
                  <li class="breadcrumb-item active">Invoice Details</li>
                </ol>
              </div>
            </div>
          </div>
        </div>
        <!-- Breadcrumb & Title -->

        <!-- Container-fluid starts-->
        <div class="container-fluid list-products">
          <div class="row">
            <!-- Data table -->
            <div class="col-sm-12 col-lg-12">
              <div class="card">
                <div class="card-header pb-0">
                  <h5>List</h5>
                  <span>Invoice Details</span>
                </div>
                <div class="card-body">
                  <div class="table-responsive product-tabl">
                    <table class="display w-100" id="invoiceListTBL">
                      <thead>
                        <tr align="center">
                          <th>#</th>
                          <th>Bill from Date</th>
                          <th>Bill to Date</th>
                          <th>Bill from Date</th>
                          <th>Price</th>
                          <th>Note</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          align="center"
                          v-for="(item, index) in invoiceList"
                          :key="index"
                        >
                          <td>{{ index + 1 }}</td>
                          <td>{{ item.bill_from_date }}</td>
                          <td>{{ item.bill_to_date }}</td>
                          <td>{{ item.calculation_method === 2 ? "Auto" : "Manual" }}</td>
                          <td>{{ parseInt(item.price) }}</td>
                          <td>{{ item.note }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "jquery/dist/jquery.min.js";
import "bootstrap/dist/css/bootstrap.min.css";
import "datatables.net-dt/js/dataTables.dataTables";
import "datatables.net-dt/css/jquery.dataTables.min.css";
import $ from "jquery";
import invoiceAPI from "../../services/invoice.API";
import jsPDF from "jspdf";
import "jspdf-autotable";
import Moment from "moment";
import customerAPI from "../../services/customer.API";

export default {
  name: "InvoiceDetails",
  components: {},
  data() {
    return {
      filter: {
        customer_id: "",
        from_date: "",
        to_date: "",
        paid_status: "",
      },
      employeeList: [],
      selectedItem: [],
      title: "",
      price: "",
      invoiceList: [],
      districtList: [],
      isCreate: true,
      update: {
        id: "",
        title: "",
        // active_status: '',
      },
      selectedDistrict: null,
      selectedPaymentStatus: null,
      itemData: [],
      printedArray: [],
      printedHeaderOBJ: {},
    };
  },
  methods: {
    selectedAction(item) {
      this.selectedItem = item.map((e) => {
        return {
          ...e,
          bill_from_date: Moment(e.bill_from_date).format("MMMM DD, YYYY"),
          bill_to_date: Moment(e.bill_to_date).format("MMMM DD, YYYY"),
          initial_date: Moment(e.initial_date).format("MMMM DD, YYYY"),
        };
      });
    },
    // select status
    selectStatus(e) {
      this.selectedPaymentStatus = Number(e.target.value);
      console.log(this.selectedPaymentStatus);
    },
    // sort price list
    sortPaymentList() {
      //   if (this.selectedPaymentStatus) {
      console.log(this.selectedPaymentStatus);
      if (this.selectedPaymentStatus === 1) {
        invoiceAPI.getPaidList().then(
          (response) => {
            this.invoiceList = response.data.data;
          },
          (err) => {
            this.$moshaToast(err.response.data.message, {
              type: "danger",
              position: "top-right",
              showIcon: true,
            });
          }
        );
      } else if (this.selectedPaymentStatus === 0) {
        {
          invoiceAPI.getUnpaidList().then(
            (response) => {
              this.invoiceList = response.data.data;
            },
            (err) => {
              this.$moshaToast(err.response.data.message, {
                type: "danger",
                position: "top-right",
                showIcon: true,
              });
            }
          );
        }
      } else {
        console.log("no select status");
      }
      //   }
    },
    // delete
    deleteType(id) {
      if (id) {
        invoiceAPI.deleteInvoice(id).then(
          (response) => {
            this.$moshaToast(response.data.message, {
              type: "success",
              position: "top-right",
              showIcon: true,
            });
            // get list
            if (this.selectedPaymentStatus === 1) {
              invoiceAPI.getPaidList().then(
                (response) => {
                  this.invoiceList = response.data.data;
                },
                (err) => {
                  this.$moshaToast(err.response.data.message, {
                    type: "danger",
                    position: "top-right",
                    showIcon: true,
                  });
                }
              );
            } else if (this.selectedPaymentStatus === 0) {
              {
                invoiceAPI.getUnpaidList().then(
                  (response) => {
                    this.invoiceList = response.data.data;
                  },
                  (err) => {
                    this.$moshaToast(err.response.data.message, {
                      type: "danger",
                      position: "top-right",
                      showIcon: true,
                    });
                  }
                );
              }
            } else {
              invoiceAPI.invoiceList().then(
                (response) => {
                  this.invoiceList = response.data.data;
                },
                (err) => {
                  this.$moshaToast(err.response.data.message, {
                    type: "danger",
                    position: "top-right",
                    showIcon: true,
                  });
                }
              );
            }
          },
          (err) => {
            this.$moshaToast(err.response.data.message, {
              type: "danger",
              position: "top-right",
              showIcon: true,
            });
          }
        );
      } else {
        this.$moshaToast("Please select invoice", {
          type: "danger",
          position: "top-right",
          showIcon: true,
        });
      }
    },

    // download pdf
    downloadPDF(itemData) {
      console.log(itemData);
      this.downloadPDF2();
      // if (itemData) {
      //   const unit = "pt";
      //   const size = "A4"; // Use A1, A2, A3 or A4
      //   const orientation = "portrait"; // portrait or landscape

      //   // header/body data
      //   const columns = [
      //     [
      //       "#",
      //       "Bill from date",
      //       "Bill to date",
      //       "Initial date",
      //       "Note",
      //       "Price",
      //       "Year",
      //     ],
      //   ];
      //   const data = itemData.items.map((e, i) => [
      //     i + 1,
      //     Moment(e.bill_from_date).format("MMMM DD, YYYY"),
      //     Moment(e.bill_to_date).format("MMMM DD, YYYY"),
      //     Moment(e.initial_date).format("MMMM DD, YYYY"),
      //     e.note,
      //     parseInt(e.price),
      //     e.year,
      //   ]);

      //   // alignment
      //   const marginLeft = 40;
      //   const doc = new jsPDF(orientation, unit, size);
      //   // new line
      //   // var pageWidth = doc.internal.pageSize.width || doc.internal.pageSize.getWidth();
      //   doc.setFontSize(13);

      //   doc.text("#" + itemData.inv_no, 40, 85);
      //   doc.setFontSize(10);

      //   doc.text("Mushok Number : " + itemData.mushok_no, 40, 105);
      //   doc.text("Mushok : " + parseInt(itemData.mushok), 40, 125);
      //   if (itemData.paid_status === 0) {
      //     doc.text("Payment Status : Unpaid", 40, 145);
      //   } else {
      //     doc.text("Payment Status : Paid", 40, 145);
      //   }
      //   doc.text("Sub-Total : " + parseInt(itemData.sub_total_price), 40, 165);
      //   doc.text("Total : " + parseInt(itemData.total_price), 40, 185);
      //   doc.setFontSize(15);
      //   var startingPage = doc.internal.getCurrentPageInfo().pageNumber;
      //   const title = "Report";

      //   let content = {
      //     startY: 220,
      //     head: columns,
      //     body: data,
      //     margin: {
      //       bottom: 120,
      //       top: 150,
      //     },
      //   };

      //   doc.setFont("helvetica", "bold");
      //   doc.setFontSize(15);
      //   doc.text(title, marginLeft, 50);

      //   doc.autoTable(content);

      //   doc.setPage(startingPage);
      //   doc.save("Invoice_Report(" + Moment(new Date()).format("YYYY-MM-DD") + ").pdf"); // Auto print code
      //   doc.autoPrint();
      // }
    },
    setPrintTableFromArray(doc = undefined, commonInfoBox = []) {
      for (let i = 0; i < commonInfoBox.length; i++) {
        doc.setLineWidth(1.3);
        
        if (Object.prototype.hasOwnProperty.call("table")) {
          doc.rect(
            commonInfoBox[i].table[0],
            commonInfoBox[i].table[1],
            commonInfoBox[i].table[2],
            commonInfoBox[i].table[3]
          );
        }

        if (Object.prototype.hasOwnProperty.call("line")) {
          doc.line(
            commonInfoBox[i].line[0],
            commonInfoBox[i].line[1],
            commonInfoBox[i].line[2],
            commonInfoBox[i].line[3]
          );
        }

        if (Object.prototype.hasOwnProperty.call("header")) {
          this.setPrintText(
            doc,
            commonInfoBox[i].header.text,
            commonInfoBox[i].header.widthPosition,
            commonInfoBox[i].header.heightPosition + 105,
            commonInfoBox[i].header.fontStyle,
            commonInfoBox[i].header.fontSize
          );
        }

        if (Object.prototype.hasOwnProperty.call("value")) {
          this.setPrintText(
            doc,
            commonInfoBox[i].value.text,
            commonInfoBox[i].value.widthPosition,
            commonInfoBox[i].value.heightPosition + 105,
            commonInfoBox[i].value.fontStyle,
            commonInfoBox[i].value.fontSize
          );
        }
      }
    },

    setPrintText(
      doc = undefined,
      text = "",
      widthPosition = 0,
      heightPosition = 0,
      fontStyle = undefined,
      fontSize = undefined
    ) {
      if (doc !== undefined) {
        if (fontSize !== undefined) {
          doc.setFontSize(fontSize);
        }

        if (fontStyle !== undefined) {
          doc.setFontStyle(fontStyle);
        }

        doc.text(text, widthPosition, heightPosition, { align: "center" });
      }
    },
    // download pdf
    downloadPDF2() {
      const columns = [
        { title: "Item", dataKey: "item" },
        { title: "Description Of Service", dataKey: "description_of_service" },
        { title: "BW (MB)", dataKey: "bm" },
        { title: "Total Amount", dataKey: "amount_due" },
      ];

      let printedArray = [
        {
          item: "Internet Service",
          description_of_service: "Monthly Charge For August 2020",
          bm: "",
          amount_due: 2000,
        },
      ];

      //  position related related info
      let userInfoBox = [
        { widthPosition: 15, heightPosition: 60, fontStyle: "bold", fontSize: 10 },
        { widthPosition: 100, heightPosition: 60, fontStyle: "normal", fontSize: 10 },
      ];

      let invoiceInfoBox = [
        { widthPosition: 345, heightPosition: 60, fontStyle: "bold", fontSize: 10 },
        { widthPosition: 450, heightPosition: 60, fontStyle: "normal", fontSize: 10 },
      ];

      let commonInfoBox = [
        {
          table: [10, 150, 100, 30], //  start width, start height,  box width, box height
          line: [11, 165, 110, 165], //  start width, start height,  end width, end height
          header: {
            text: "BIN No",
            widthPosition: 35,
            heightPosition: 55,
            fontStyle: "bold",
            fontSize: 10,
          },
          value: {
            text: "000479163-0505",
            widthPosition: 15,
            heightPosition: 70,
            fontStyle: "normal",
            fontSize: 10,
          },
        },
        {
          table: [130, 150, 100, 30], //  start width, start height,  box width, box height
          line: [130, 165, 230, 165], //  start width, start height,  end width, end height
          header: {
            text: "VAT Reg. No",
            widthPosition: 160,
            heightPosition: 55,
            fontStyle: "bold",
            fontSize: 10,
          },
          value: {
            text: "000479163-0505",
            widthPosition: 150,
            heightPosition: 70,
            fontStyle: "normal",
            fontSize: 10,
          },
        },
        {
          table: [10, 185, 100, 30], //  start width, start height,  box width, box height
          line: [11, 200, 110, 200], //  start width, start height,  end width, end height
          header: {
            text: "Previous Balance",
            widthPosition: 15,
            heightPosition: 90,
            fontStyle: "bold",
            fontSize: 10,
          },
          value: {
            text: "000479163-0505",
            widthPosition: 15,
            heightPosition: 105,
            fontStyle: "normal",
            fontSize: 10,
          },
        },
        {
          table: [130, 185, 100, 30], //  start width, start height,  box width, box height
          line: [130, 200, 230, 200], //  start width, start height,  end width, end height
          header: {
            text: "Payments",
            widthPosition: 160,
            heightPosition: 90,
            fontStyle: "bold",
            fontSize: 10,
          },
          value: {
            text: "",
            widthPosition: 150,
            heightPosition: 105,
            fontStyle: "normal",
            fontSize: 10,
          },
        },
        {
          table: [250, 185, 100, 30], //  start width, start height,  box width, box height
          line: [250, 200, 350, 200], //  start width, start height,  end width, end height
          header: {
            text: "Adjustments",
            widthPosition: 270,
            heightPosition: 90,
            fontStyle: "bold",
            fontSize: 10,
          },
          value: {
            text: "",
            widthPosition: 255,
            heightPosition: 105,
            fontStyle: "normal",
            fontSize: 10,
          },
        },
        {
          table: [370, 185, 100, 30], //  start width, start height,  box width, box height
          line: [370, 200, 470, 200], //  start width, start height,  end width, end height
          header: {
            text: "Current Changes",
            widthPosition: 380,
            heightPosition: 90,
            fontStyle: "bold",
            fontSize: 10,
          },
          value: {
            text: "2,100",
            widthPosition: 375,
            heightPosition: 105,
            fontStyle: "normal",
            fontSize: 10,
          },
        },
        {
          table: [490, 185, 100, 30], //  start width, start height,  box width, box height
          line: [490, 200, 590, 200], //  start width, start height,  end width, end height
          header: {
            text: "Amount Due",
            widthPosition: 510,
            heightPosition: 90,
            fontStyle: "bold",
            fontSize: 10,
          },
          value: {
            text: "10,500",
            widthPosition: 500,
            heightPosition: 105,
            fontStyle: "normal",
            fontSize: 10,
          },
        },
        {
          header: {
            text: "PREPAID INTERNET BIL",
            widthPosition: 385,
            heightPosition: 74,
            fontStyle: "bold",
            fontSize: 10,
          },
        },
        {
          header: {
            text: "Payment received after 31-Aug-2020 shall be reflected in next bill",
            widthPosition: 310,
            heightPosition: 130,
            fontStyle: "normal",
            fontSize: 9,
          },
        },
        {
          header: {
            text: "Summary Of Current Charges",
            widthPosition: 10,
            heightPosition: 135,
            fontStyle: "bold",
            fontSize: 9,
          },
        },
        {
          header: {
            text: "In Words (BDT): Ten Thousand Five Hundred Only.",
            widthPosition: 10,
            heightPosition: 393,
            fontStyle: "bold",
            fontSize: 10,
          },
        },
        {
          header: {
            text: "Notes:",
            widthPosition: 10,
            heightPosition: 405,
            fontStyle: "bold",
            fontSize: 10,
          },
        },
        {
          header: {
            text:
              " 1. For Cash/Advance payment please pay at INFOCOM LIMITED office from 9.00 AM to 5.30 PM",
            widthPosition: 10,
            heightPosition: 415,
            fontStyle: "normal",
            fontSize: 8,
          },
          value: {
            text:
              "    at Uday Tower (9th Floor), Plot #57 & 57/A, Gulshan Avenue, Dhaka -1212",
            widthPosition: 10,
            heightPosition: 425,
            fontStyle: "normal",
            fontSize: 8,
          },
        },
        {
          value: {
            text: " 2. Please pay within due date and enjoy uninterrupted service",
            widthPosition: 10,
            heightPosition: 435,
            fontStyle: "bold",
            fontSize: 8,
          },
        },
        {
          value: {
            text: " 3. Mode of Payment: A/C payee Cheque / PO / Cash or by bKash:",
            widthPosition: 10,
            heightPosition: 445,
            fontStyle: "normal",
            fontSize: 8,
          },
        },
        {
          table: [370, 185, 100, 30], //  start width, start height,  box width, box height
          line: [370, 200, 470, 200], //  start width, start height,  end width, end height
          header: {
            text: "Current Changes",
            widthPosition: 380,
            heightPosition: 90,
            fontStyle: "bold",
            fontSize: 10,
          },
          value: {
            text: "2,100",
            widthPosition: 375,
            heightPosition: 105,
            fontStyle: "normal",
            fontSize: 10,
          },
        },
      ];

      var doc = new jsPDF("p", "pt", "a4", true);

      var pageWidth = doc.internal.pageSize.width || doc.internal.pageSize.getWidth();
      // var tableHight = 0;

      // doc.setFontSize(14);
      // doc.text("Invoice", 260, 25, { align: 'right' });

      this.setPrintText(doc, "Invoice", 260, 25, "bold", 14); // Invoice Text
      this.setPrintText(doc, "Issued To", 10, 45, "bold", 10); // Issued To Text

      doc.rect(10, 50, 230, 95);

      // Name Text
      this.setPrintText(
        doc,
        "Name:",
        userInfoBox[0].widthPosition,
        userInfoBox[0].heightPosition,
        userInfoBox[0].fontStyle,
        userInfoBox[0].fontSize
      );
      this.setPrintText(
        doc,
        "Ashraful Islam Sheiblu",
        userInfoBox[1].widthPosition,
        userInfoBox[1].heightPosition,
        userInfoBox[1].fontStyle,
        userInfoBox[1].fontSize
      );

      // Designation Text
      this.setPrintText(
        doc,
        "Designation:",
        userInfoBox[0].widthPosition,
        userInfoBox[0].heightPosition + 15,
        userInfoBox[0].fontStyle,
        userInfoBox[0].fontSize
      );
      this.setPrintText(
        doc,
        "Software Engineer.",
        userInfoBox[1].widthPosition,
        userInfoBox[1].heightPosition + 15,
        userInfoBox[1].fontStyle,
        userInfoBox[1].fontSize
      );

      // Company Text
      this.setPrintText(
        doc,
        "Company:",
        userInfoBox[0].widthPosition,
        userInfoBox[0].heightPosition + 30,
        userInfoBox[0].fontStyle,
        userInfoBox[0].fontSize
      );
      this.setPrintText(
        doc,
        "Medina Tech Ltd.",
        userInfoBox[1].widthPosition,
        userInfoBox[1].heightPosition + 30,
        userInfoBox[1].fontStyle,
        userInfoBox[1].fontSize
      );

      // Address Text
      this.setPrintText(
        doc,
        "Address:",
        userInfoBox[0].widthPosition,
        userInfoBox[0].heightPosition + 45,
        userInfoBox[0].fontStyle,
        userInfoBox[0].fontSize
      );
      this.setPrintText(
        doc,
        "Dhaka Bangladesh.",
        userInfoBox[1].widthPosition,
        userInfoBox[1].heightPosition + 45,
        userInfoBox[1].fontStyle,
        userInfoBox[1].fontSize
      );

      doc.setLineWidth(0.5);
      doc.line(11, 125, 240, 125);
      doc.setFontStyle("normal");

      // Cont. Number Text
      this.setPrintText(
        doc,
        "Customer Ref: ",
        userInfoBox[0].widthPosition,
        userInfoBox[0].heightPosition + 75,
        userInfoBox[0].fontStyle,
        userInfoBox[0].fontSize
      );
      this.setPrintText(
        doc,
        "100002",
        userInfoBox[1].widthPosition,
        userInfoBox[0].heightPosition + 75,
        userInfoBox[1].fontStyle,
        userInfoBox[1].fontSize
      );

      doc.rect(340, 50, 240, 105);

      // Customer Ref Text
      this.setPrintText(
        doc,
        "Customer Ref:",
        invoiceInfoBox[0].widthPosition,
        invoiceInfoBox[0].heightPosition,
        invoiceInfoBox[0].fontStyle,
        invoiceInfoBox[0].fontSize
      );
      this.setPrintText(
        doc,
        "100002",
        invoiceInfoBox[1].widthPosition,
        invoiceInfoBox[1].heightPosition,
        invoiceInfoBox[1].fontStyle,
        invoiceInfoBox[1].fontSize
      );

      // P.O Ref. Text
      this.setPrintText(
        doc,
        "P.O Ref.:",
        invoiceInfoBox[0].widthPosition,
        invoiceInfoBox[0].heightPosition + 15,
        invoiceInfoBox[0].fontStyle,
        invoiceInfoBox[0].fontSize
      );
      this.setPrintText(
        doc,
        "",
        invoiceInfoBox[1].widthPosition,
        invoiceInfoBox[1].heightPosition + 15,
        invoiceInfoBox[1].fontStyle,
        invoiceInfoBox[1].fontSize
      );

      // Quotation Ref. Text
      this.setPrintText(
        doc,
        "Quotation Ref.:",
        invoiceInfoBox[0].widthPosition,
        invoiceInfoBox[0].heightPosition + 30,
        invoiceInfoBox[0].fontStyle,
        invoiceInfoBox[0].fontSize
      );
      this.setPrintText(
        doc,
        "",
        invoiceInfoBox[1].widthPosition,
        invoiceInfoBox[1].heightPosition + 30,
        invoiceInfoBox[1].fontStyle,
        invoiceInfoBox[1].fontSize
      );

      //Invoice No. Text
      this.setPrintText(
        doc,
        "Invoice No.",
        invoiceInfoBox[0].widthPosition,
        invoiceInfoBox[0].heightPosition + 45,
        invoiceInfoBox[0].fontStyle,
        invoiceInfoBox[0].fontSize
      );
      this.setPrintText(
        doc,
        "1005705",
        invoiceInfoBox[1].widthPosition,
        invoiceInfoBox[1].heightPosition + 45,
        invoiceInfoBox[1].fontStyle,
        invoiceInfoBox[1].fontSize
      );

      // Issue Date Text
      this.setPrintText(
        doc,
        "Issue Date:",
        invoiceInfoBox[0].widthPosition,
        invoiceInfoBox[0].heightPosition + 60,
        invoiceInfoBox[0].fontStyle,
        invoiceInfoBox[0].fontSize
      );
      this.setPrintText(
        doc,
        "01-08-2020",
        invoiceInfoBox[1].widthPosition,
        invoiceInfoBox[1].heightPosition + 60,
        invoiceInfoBox[1].fontStyle,
        invoiceInfoBox[1].fontSize
      );

      // Due Date. Text
      this.setPrintText(
        doc,
        "Due Date:",
        invoiceInfoBox[0].widthPosition,
        invoiceInfoBox[0].heightPosition + 75,
        invoiceInfoBox[0].fontStyle,
        invoiceInfoBox[0].fontSize
      );
      this.setPrintText(
        doc,
        "08-08-2020",
        invoiceInfoBox[1].widthPosition,
        invoiceInfoBox[1].heightPosition + 75,
        invoiceInfoBox[1].fontStyle,
        invoiceInfoBox[1].fontSize
      );

      // Billing Period Text
      this.setPrintText(
        doc,
        "Billing Period:",
        invoiceInfoBox[0].widthPosition,
        invoiceInfoBox[0].heightPosition + 90,
        invoiceInfoBox[0].fontStyle,
        invoiceInfoBox[0].fontSize
      );
      this.setPrintText(
        doc,
        "01-08-2020 to 08-08-2020",
        invoiceInfoBox[1].widthPosition,
        invoiceInfoBox[1].heightPosition + 90,
        invoiceInfoBox[1].fontStyle,
        invoiceInfoBox[1].fontSize
      );

      // Billing Period Text
      this.setPrintText(
        doc,
        "Deposit:",
        invoiceInfoBox[0].widthPosition,
        invoiceInfoBox[0].heightPosition + 105,
        invoiceInfoBox[0].fontStyle,
        invoiceInfoBox[0].fontSize
      );
      this.setPrintText(
        doc,
        "0.00",
        invoiceInfoBox[1].widthPosition,
        invoiceInfoBox[1].heightPosition + 105,
        invoiceInfoBox[1].fontStyle,
        invoiceInfoBox[1].fontSize
      );

      //  Common invoice print
      this.setPrintTableFromArray(doc, commonInfoBox);

      doc.autoTable(columns, printedArray, {
        theme: "plain",
        styles: { fontSize: 10, lineColor: [0, 0, 0], lineWidth: 0.2 },
        tableWidth: pageWidth - 15,
        showHeader: "everyPage",
        avoidPageSplit: false,
        margin: { top: 250, right: 0, left: 10 },
        // didDrawPage: function (data) {
        //   // tableHight = data.cursor.y;
        // },
      });

      // tableHight += 20;

      // Amount relater calculation

      var amoutCalculation = [
        {
          table: [10, 400, pageWidth - 200, 20], //  start width, start height,  box width, box height
          header: {
            text: "VAT 5%",
            widthPosition: pageWidth / 3 - 25,
            heightPosition: 308,
            fontStyle: "bold",
            fontSize: 10,
          },
        },
        {
          table: [10, 425, pageWidth - 200, 20], //  start width, start height,  box width, box height
          header: {
            text: "Current Invoice Amount",
            widthPosition: pageWidth / 3 - 50,
            heightPosition: 333,
            fontStyle: "bold",
            fontSize: 10,
          },
        },
        {
          table: [10, 450, pageWidth - 200, 20], //  start width, start height,  box width, box height
          header: {
            text: "Previous Balance",
            widthPosition: pageWidth / 3 - 40,
            heightPosition: 355,
            fontStyle: "bold",
            fontSize: 10,
          },
        },
        {
          table: [10, 465, pageWidth - 200, 20], //  start width, start height,  box width, box height
          header: {
            text: "Total Due Amount",
            widthPosition: pageWidth / 3 - 40,
            heightPosition: 376,
            fontStyle: "bold",
            fontSize: 10,
          },
        },
        {
          table: [pageWidth - pageWidth / 3.5, 400, 150, 20], //  start width, start height,  box width, box height
          header: {
            text: "100",
            widthPosition: pageWidth - 75,
            heightPosition: 308,
            fontStyle: "bold",
            fontSize: 10,
          },
        },
        {
          table: [pageWidth - pageWidth / 3.5, 425, 150, 20], //  start width, start height,  box width, box height
          header: {
            text: "2,100",
            widthPosition: pageWidth - 75,
            heightPosition: 333,
            fontStyle: "bold",
            fontSize: 10,
          },
        },
        {
          table: [pageWidth - pageWidth / 3.5, 450, 150, 20], //  start width, start height,  box width, box height
          header: {
            text: "8,400",
            widthPosition: pageWidth - 75,
            heightPosition: 355,
            fontStyle: "bold",
            fontSize: 10,
          },
        },
        {
          table: [pageWidth - pageWidth / 3.5, 465, 150, 20], //  start width, start height,  box width, box height
          header: {
            text: " 10,500",
            widthPosition: pageWidth - 75,
            heightPosition: 376,
            fontStyle: "bold",
            fontSize: 10,
          },
        },
      ];

      this.setPrintTableFromArray(doc, amoutCalculation);

      doc.save(`invoice-no.pdf`);

      // Auto print code
      doc.autoPrint();
      try {
        window.open(doc.output("bloburl"), "_blank");
      } catch (e) {
        console.log(e);
      }
    },
    // filter data
    filterAction() {
      console.log(this.filter, "filterData");
      let data = {
        customer_id: this.filter.customer_id,
        from_date: this.filter.from_date,
        to_date: this.filter.to_date,
        paid_status: Number(this.filter.paid_status),
      };
      invoiceAPI.searchInvoice(data).then(
        (res) => {
          this.invoiceList = res.data.data;

          if (res?.data?.data?.length === 0) {
            this.$moshaToast("No data found", {
              type: "info",
              position: "top-right",
              showIcon: true,
            });
          }
        },
        (err) => {
          this.$moshaToast(err.response.data.message, {
            type: "danger",
            position: "top-right",
            showIcon: true,
          });
        }
      );
    },
  },
  mounted() {
    var url = window.location.href;
    var id = url.substring(url.lastIndexOf("/") + 1);
    //   list
    invoiceAPI.getDetails(Number(id)).then(
      (response) => {
        this.invoiceList = response?.data?.data?.items.map((e) => {
          return {
            ...e,
            bill_from_date: Moment(e.bill_from_date).format("MMMM DD, YYYY"),
            bill_to_date: Moment(e.bill_to_date).format("MMMM DD, YYYY"),
            initial_date: Moment(e.initial_date).format("MMMM DD, YYYY"),
          };
        });
        setTimeout(() => {
          $("#invoiceListTBL").DataTable({
            lengthMenu: [
              [10, 25, 50, -1],
              [10, 25, 50, "All"],
            ],
            pageLength: 10,
            info: false,
            targets: "no-sort",
            bSort: false,
            order: [],
            bFilter: true,
            bInfo: false,
            //   bLengthChange: false,
            bDestroy: true,
          });
        });
      },
      (err) => {
        this.$moshaToast(err.response.data.message, {
          type: "danger",
          position: "top-right",
          showIcon: true,
        });
      }
    );

    // emp list
    customerAPI.getList().then((response) => {
      this.employeeList = response.data.data;
    });
  },
};
</script>

<style scoped>
.btn {
  margin: 5px;
}

th {
  text-align: center !important;
}

th,
td {
  text-align: center;
  border: 1px solid #f3f3f3;
  padding: 10px 0;
}
</style>
